export default __webpack_public_path__ + "cad2c2b095e143a947c2841852d57024.png";